module.exports = __webpack_public_path__ + "static/media/bg-vip.ea92128b.png";